'use strict';
angular.module('ICMAnalyticsHelperService', ['MW.Framework.ICMEntitlementService']).provider('ICMAnalyticsHelperService', [function() {

    var defaultProperties = {
            isInternalUser: false
        },
        userIdentity = null,
        userRole = 'Anonymous User',
        product = 'Desktop',
        eventQueue = [],
        isInitialized = false,
        userIdentitySet = false,
        provider = this,
        pageList = [
            {val: 'Inbox', pattern: '/inbox'},
            {val: 'Dashboards', pattern: '/dashboard/collections'},
            {val: 'Dashboards', pattern: '/dashboard/viewer'},
            {val: 'Maximized Widget', pattern: '/widget_'},
            {val: 'Search', pattern: '/search/list'},
            {val: 'Search', pattern: '/search/results'},
            {val: 'Search Update', pattern: '/search/edit'},
            {val: 'Tags', pattern: '/tag'},
            {val: 'Personal Settings', pattern: '/settings/personal'},
            {val: 'Report Settings', pattern: '/settings/report'},
            {val: 'RSS Feed', pattern: '/settings/rss'},
            {val: 'Manage Users', pattern: '/settings/users'},
            {val: 'Account Information', pattern: '/settings/account'},
            {val: 'Home', pattern: '/dashboard/index'},
            {val: 'Output Manager', pattern: '/output'},
            {val: 'Influencers', pattern: '/influencers'},
            {val: 'Influencers', pattern: '/outreach'}
        ];

    // Basic stuff available both on the provider, and on the actual service it provides.    
    this.getDefaultProperties = function() {
        return defaultProperties;
    };

    this.getUserIdentity = function () {
        return userIdentity;
    };

    this.getUserRole = function() {
        return userRole;
    };

    this.getProduct = function() {
        return product;
    };

    this.getAnalyticsDetail = function($injector, $q) {
        var userObject = this.getUserDetail($injector, false),
            companyObject = this.getCompanyDetail($injector, false),
            promises = [],
            trackingUserCompanyDetail = {},
            role,
            defer = $q.defer(),
            ICMEntitlementService = $injector.get('ICMEntitlementService');

        promises.push(userObject);
        promises.push(ICMEntitlementService.getEntitlements());

        $q.all(promises).then(function(results) {
            var user = results[0].user,
                entitlements = results[1];

            if(user  && companyObject) {
                role = results[0].companyMembership.role;
                trackingUserCompanyDetail = {
                    companyId: companyObject._id,
                    companyCountry: companyObject.country,
                    companyCreationDate: companyObject.created,
                    loginUserId: user._id,
                    userName: user.username,
                    firstName: user.firstName,
                    lastName: user.lastName,
                    email: user.email,
                    userTimezone: user.timezone,
                    userType: (user.isInternal ? 'Internal' : 'External'),
                    userRole: role,
                    createdAt: user.created 
                };
                if(companyObject.accountId) {
                    trackingUserCompanyDetail.companyAccountId = companyObject.accountId;
                }
                if(companyObject.opportunityId) {
                    trackingUserCompanyDetail.companyOpportunityId = companyObject.opportunityId;
                }
                if (entitlements) {
                    trackingUserCompanyDetail.entitlements = entitlements;
                } 
            }
            defer.resolve(trackingUserCompanyDetail);
        })
        .catch(function(err) {
            defer.reject(err);
        });

        return defer.promise;
    };

    this.getUserDetail = function($injector, wait) {
        var ICMUserService = $injector.get('ICMUserService'),
            completeUserIdentity = ICMUserService.getIdentity(wait);
            return completeUserIdentity;
    };

    this.getCompanyDetail = function($injector, wait) {
        var CoreCompanyService = $injector.get('CoreCompanyService'),
            completeCompanyIdentity = CoreCompanyService.getCurrent(wait);
            return completeCompanyIdentity;
    };

    this.getPageName = function(url) {
        var pageName = '';
        angular.forEach(pageList, function (pageListObj) {
            if(url.match(pageListObj.pattern)) {
                pageName = pageListObj.val;
            }
        });
        return pageName;
    };

    this.runWhenReady = function(fn) {
        if (isInitialized) {
            fn();
        } else {
            eventQueue.push(fn);
        }
    };

    var executeQueue = function() {
        while (eventQueue.length > 0) {
            // Yes, this looks silly. It pops the last function off of eventQueue and runs it immediately.
            eventQueue.pop()();
        }
    };

    // Provider object to serve up the service.
        // Getter method for the service.
    this.$get = ['$rootScope', '$injector', function($rootScope, $injector) {

        // Helper method that we call on events, or we can call manually to trigger an update if needed.
        var updateLocalData = function() {
            var ICMUserService = $injector.get('ICMUserService'),
                CoreCompanyService = $injector.get('CoreCompanyService'),
                identity = ICMUserService.getIdentity();
            identity.then(function(id){
                userIdentity = id.user.email + ' (' + id.user._id + ') ' + (CoreCompanyService.getName() || 'Unknown Company');
                userRole = (id.user.isInternal ? 'Internal ' : '') + ICMUserService.getRoleName();

                defaultProperties.isInternalUser = id.user.isInternal;
                defaultProperties.userRole = userRole;
                isInitialized = true;

                if (userIdentitySet === false) {
                    $rootScope.$broadcast('analyticsUpdate');
                    userIdentitySet = true;
                }

                executeQueue();
            });
        };

        // Here's our service definition!
        return {
            getDefaultProperties: provider.getDefaultProperties,
            getUserIdentity: provider.getUserIdentity,
            getUserRole: provider.getUserRole,
            getProduct: provider.getProduct,
            runWhenReady: provider.runWhenReady,
            updateLocalData: updateLocalData,
            getUserDetail: provider.getUserDetail,
            getCompanyDetail: provider.getCompanyDetail,
            getAnalyticsDetail: provider.getAnalyticsDetail
        };

    }];

    return this;
}]).run(['$rootScope', 'ICMAnalyticsHelperService', function($rootScope, ICMAnalyticsHelperService) {
    $rootScope.$on('companyChanged', ICMAnalyticsHelperService.updateLocalData);
}]);
